










































import { mapDeps } from '~/plugins/dependency-container/utils'
import ClassifiedExtraViewService from '~/services/classified/ClassifiedExtraViewService'
import { extrasIcons, fallbackIcon } from '~/constants/classified/extra'
import ExtrasCol from '~/components/car/classifieds/view/partials/ExtrasCol.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { ExtrasCol, CCard, CExpandableContent },
  props: {
    extras: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    inTrades: {
      type: Boolean,
      required: false,
      default: false
    },
    withoutCard: { type: Boolean, default: false },
    preExpanded: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    extrasIcons,
    fallbackIcon
  }),
  computed: {
    ...mapDeps({ classifiedExtraViewService: ClassifiedExtraViewService })
  },
  methods: {
    getIcon(name: string) {
      return extrasIcons[name] || fallbackIcon
    }
  }
})
